export const AI_STUDIO_ROUTES = {
  campaigns: '/ai-studio/campaigns',
  salesDocuments: '/ai-studio/sales-documents',
  documentStudio: '/ai-studio/document-studio',
};

export const STUDIO_ROUTE_TO_KEY = {
  [AI_STUDIO_ROUTES.campaigns]: 'campaigns',
  [AI_STUDIO_ROUTES.salesDocuments]: 'sales-documents',
  [AI_STUDIO_ROUTES.documentStudio]: 'document-studio',
};

export const CAMPAIGN_DEFAULT_INPUTS = {
  goal: '',
  audienceFilter: 'all_customers',
  productFocus: '',
  tone: 'helpful',
  callToActionLabel: 'Learn more',
  callToActionUrl: 'https://example.com',
  templateName: '',
  existingTemplateId: '',
};

export const SALES_DEFAULT_INPUTS = {
  customerId: '',
  documentDate: '',
  paymentMode: 'Credit',
  layoutTemplateId: '',
  sourceDocumentId: '',
  items: [
    {
      productId: '',
      quantity: 1,
      pricePerUnit: 0,
      taxIds: [],
    },
  ],
};

export const DOCUMENT_STUDIO_DEFAULT_INPUTS = {
  documentType: 'invoice',
  designGoal: '',
  styleDirection: '',
  requiredSections: ['header', 'customerInfo', 'itemsTable', 'summary'],
  existingTemplateId: '',
  fieldRequest: {
    label: '',
    fieldType: 'text',
    sectionKey: 'customFields',
    width: 'full',
    required: false,
    helpText: '',
    placeholder: '',
  },
};

export function resolveStudioKeyFromPath(pathname = '') {
  if (pathname.startsWith(AI_STUDIO_ROUTES.salesDocuments)) {
    return 'sales-documents';
  }

  if (pathname.startsWith(AI_STUDIO_ROUTES.documentStudio)) {
    return 'document-studio';
  }

  return 'campaigns';
}
